import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Blog2D() {
  const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
      const [formType, setFormType] = useState(""); // stores which button opened the form
  const [contactForm, setContactForm] = useState({
    fullname: "",
    company: "",
    website: "",
    email: "",
    phone: "",
    message: "",
  });
  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactForm((prev) => ({ ...prev, [name]: value }));
  };
  
  
  const isBusinessEmail = (email) => {
    const freeDomains = [
      "gmail.com",
      "yahoo.com",
      "hotmail.com",
      "outlook.com",
      "aol.com",
      "icloud.com",
      "mail.com",
      "live.com"
    ];
    const domain = email.split("@")[1]?.toLowerCase();
    if (!domain) return false;
    return !freeDomains.includes(domain);
  };
  
  
  const handleContactSubmit = async (e) => {
    e.preventDefault();
   
    setLoading(true); // show loading message
    const { fullname, company, website, email, phone, message} = contactForm;
  
  
    // Basic validation
    if (!fullname || !email || !message || !company || !phone ) {
      alert("Please fill all required fields.");
        setLoading(false); // show loading message
  
      return;
    }
  if (!isBusinessEmail(email)) {
      alert("Please enter a business email, not Gmail/Yahoo/etc.");
        setLoading(false); // show loading message
  
      return;
    }
   
  
    try {
        try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
      const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
     body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

      });
  
      if (response.ok) {
         setShowSuccessModal(true);  // ✅ This triggers modal to open
         setLoading(false); // show loading message
         setContactForm({
          fullname: "",
          company: "",
          website: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        alert("Error sending message.");
      }
    } catch (err) {
      console.error(err);
      alert("Error sending message.");
    }
  };
    
  return (
    <div>
      <Header />
      <main>
            <AnimatePresence>
              {showSuccessModal && (
                <motion.div
                  className="modal-overlay show"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                  }}
                >
                  <motion.div
                    className="modal show"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      background: "#fff",
                      padding: "30px",
                      borderRadius: "10px",
                      width: "400px",
                      textAlign: "center",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                    }}
                  >
                    <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                      Message Sent!
                    </h2>
                    <p>Thank you for contacting us. We will get back to you shortly.</p>
                    <button className="vc rg lk gh ml il hi gi _l"
                      onClick={() => setShowSuccessModal(false)}
                     
                    >
                      Close
                    </button>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
            
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
             
              <div className="container">
               <div className="left">
          <img src="../images/blogim2.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
               TOFU (Top of Funnel): The Gateway to Growth
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span>  Oct 24, 2025
                </li>
                  <li>
                   <span className="rc kk wm">Published by:</span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
            <br/>
              <p className="mk3 ij">
          Why Top of Funnel Strategy Is the Backbone of Effective Demand Generation
              </p>

                <p className="jutfy">
In today’s saturated B2B landscapes, buyers are more informed, more skeptical, and more selective than ever. If you're only focusing on closing deals or nurturing leads halfway down the pipeline, you're missing a massive opportunity to drive long-term growth.        
<br/>
<br/>
That opportunity lies at the Top of the Funnel (TOFU) — the awareness stage of your demand generation strategy.<br/>
<br/>
TOFU is not just the starting point of the buyer’s journey; it’s where your brand earns attention, builds trust, and sets the stage for conversion. Let’s break down why TOFU is so important, how it feeds the rest of your marketing funnel, and what successful TOFU strategies look like.      </p>
              <p className="mb bgimh">
               What Is TOFU in Demand Generation?
              </p>
 <p className="jutfy">
TOFU refers to the topmost stage in the marketing funnel, where potential customers first become aware of your brand, product, or service. At this stage, the audience is typically:              </p>
              <ul className="jutfy">
                <li>
                  •	Unaware of your solution </li>
  <li>•	Researching broadly around a problem </li>
  <li>•	Looking for education, insight, or inspiration — not a sales pitch

                </li>
              </ul>
              
 <p className="jutfy">
TOFU content and campaigns are designed to attract, engage, and educate — not convert (yet). The goal is to plant the seed of interest and position your brand as a trusted resource in your niche.              </p>

               <p className="mb bgimh">
              Why TOFU Is Critical to Demand Generation Success
              </p>
 <p className="jutfy">
Demand generation is a full-funnel approach — but TOFU lays the foundation. Here’s why you should take TOFU seriously:              </p>
              <p className="mb bgimh">
              1. Builds Brand Awareness and Visibility
              </p>
 <p className="jutfy">
You can’t sell to people who don’t know you exist. TOFU introduces your brand to new audiences in a non-intrusive way. With smart content distribution (SEO, social, paid, partnerships), you get in front of the right people — early.              </p>


                <p className="mb bgimh">
          2. Captures Audience Attention Before Competitors
              </p>

                <p className="jutfy">
If you're present at the awareness stage, you're likely to shape the way prospects frame their problem and explore solutions. This first-mover advantage increases your chance of becoming the vendor of choice later.              </p>
              <p className="mb bgimh">
               3. Generates Qualified Traffic for Lower Funnel Conversion
              </p>
 <p className="jutfy">
Strong TOFU campaigns bring in relevant traffic — not just anyone. When executed correctly, TOFU strategies attract the kind of visitors that are more likely to move down the funnel and convert.              </p>
                <p className="mb bgimh">
              4. Educates and Nurtures Without Pressure
              </p>
 <p className="jutfy">
TOFU content builds trust without selling. By helping your audience understand their problem better, you naturally position your brand as a helpful authority. This makes it easier to nurture them into leads later on.              </p>

                <p className="mb bgimh">
        5. Feeds Retargeting and Lead Nurturing Campaigns
              </p>
 <p className="jutfy">
Even if TOFU visitors don’t convert immediately, their interactions become data points for retargeting, segmentation, and personalization. You can bring them back into your funnel with middle-of-funnel (MOFU) or bottom-of-funnel (BOFU) content when they're ready.              </p>

               <p className="mb bgimh">
          What Makes a TOFU Campaign Successful?
              </p>
 <p className="jutfy">
   A strong TOFU strategy doesn’t mean shouting louder — it means offering value upfront. Here’s how to do it right:
              </p>
                 <p className="mb bgimh">
         Create Content That Solves Real Problems
              </p>
              <p className="jutfy">Think blog posts, checklists, infographics, podcasts, and short videos that address:</p>
              <ul className="jutfy">
                <li>•	Common pain points</li>
                <li>•	Emerging trends</li>
                <li>•	Industry how-tos</li>
                <li>•	Educational guides</li>
              </ul>

                 <p className="mb bgimh">
          Leverage SEO and Paid Media to Boost Reach
              </p>

                <p className="jutfy">
                  Great content is useless if no one sees it. Use SEO best practices to target top-of-funnel keywords like “how to improve customer onboarding” or “marketing automation tips.”
                  <br/>
                  Support your organic strategy with paid social (LinkedIn, Facebook), native ads, or Google Display to widen your reach and generate more top-funnel traffic.
              </p>
              <p className="mb bgimh">
              Use Lead Magnets Strategically
              </p>
 <p className="jutfy">
Offer downloadable assets like:              </p>
              <ul className="jutfy">
                <li>•	Ebooks</li>
<li>•	Industry reports</li>
<li>•	Toolkits</li>
<li>•	Templates</li>
              </ul>

              <p className="jutfy">
                These act as value exchanges — giving your visitors something useful in return for their email, allowing you to start nurturing them.
              </p>
              
               <p className="mb bgimh">
             Collaborate with Influencers or Partners
              </p>
              <p className="jutfy">
Leverage co-marketing opportunities, podcast guest spots, webinars, or shared blog content with industry influencers or aligned brands. This helps you tap into existing communities and establish credibility.              </p>
                 <p className="mb bgimh">
             Key TOFU Metrics to Track
              </p>
              <p className="jutfy">
               While TOFU isn’t about direct conversion, it should drive measurable outcomes. Important metrics to monitor include:
              </p>
              <ul className="jutfy">
                <li>•	Website traffic from TOFU channels
</li>
<li>•	New visitors vs. returning
</li>
<li>•	Time on page and bounce rate
</li>
<li>•	Content downloads
</li>
<li>•	Social shares and engagement
</li>
<li>•	Newsletter sign-ups
</li>
<li>•	Branded search growth over time
</li>
              </ul>
               <p className="jutfy">
These KPIs give insight into how well your awareness efforts are performing and whether you’re attracting the right audience.              </p>

               <p className="mb bgimh">
           Pro Tip: Align TOFU With the Full Funnel
              </p>
              <p className="jutfy">
While TOFU is critical, it doesn’t exist in a vacuum. Make sure there are clear paths for progression, such as:              </p>
               <ul className="jutfy">
                <li>
•	CTAs leading to MOFU content (e.g., case studies, webinars) </li>
<li>•	Lead nurturing email sequences </li>
<li>•	Retargeting campaigns based on content interaction </li>
<li>•	Intelligent lead scoring models to qualify engaged prospects

                </li>
               </ul>
    <p className="jutfy">This seamless transition ensures your TOFU efforts don’t just attract — they convert.</p>
             <p className="mb bgimh">
         Final Thoughts: TOFU Is the First Step Toward Trust
              </p>
            <p className="jutfy">
Demand generation isn’t about pushing products — it’s about building trust through value. And TOFU is where that journey begins. When you lead with relevance, solve real problems, and educate without selling, you create a relationship that lasts.
<br/>
<br/>
So if your demand gen strategy is falling flat, take a closer look at your top-of-funnel game. You might find that a better first impression is the key to long-term pipeline growth.
            </p>
            <p className="jutfy">Want to Build a TOFU Engine That Converts? Contact button</p>
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
           <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("Blog: TOFU (Top of Funnel): The Gateway to Growth");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Blog2D;
